import $ from "jquery";
import InitGridObj from "../../../dx/dxInitUtils/initGridObj";
import {GoingUtils,AssertUtils} from "goingutils";

/**
 * 岗位信息加载后 需要判断是否被选中了 如果选中了 则需要打勾当前记录
 * @param cellObj
 * @private
 */
function _afterLoadData(cellObj) {
    cellObj.alreadySelGrid.forEachRow(function (id) {
        if(cellObj.leftTopGrid.getRowIndex(id)>=0){
            cellObj.leftTopGrid.setRowIsSelected(id);
        }
    });
}

/**
 * 表格多选数据
 * @param cellObj
 * @param rowId
 * @private
 */
function _gridMoreSelRecord(cellObj,rowId) {
    let selGrid=cellObj.leftTopGrid;
    let dataJson = selGrid.getRowRecord(rowId);
    //表示选中
    if (GoingUtils.parseBoolean(dataJson.selBox)) {
        cellObj.addLeftTopRecordToAlreadyGrid(rowId,selGrid,cellObj.dataFrom);
    } else {
        cellObj.delRecordFromAlreadyGrid(rowId);
    }
}

/**
 * 表格单选数据
 * @param cellObj
 * @param rowId
 * @private
 */
function _gridSingleSelRecord(cellObj, rowId) {
    //循环已选数据里面存在于单选表格的数据 则进行删除 而把选中的数据添加进来
    let alreadGrid=cellObj.alreadySelGrid;
    alreadGrid.forEachRow(function (rowId) {
        alreadGrid.deleteRow(rowId);
    });
    let selGrid=cellObj.leftTopGrid;
    cellObj.addLeftTopRecordToAlreadyGrid(rowId,selGrid,cellObj.dataFrom);
}


let GridPanelUtils = {
    //缓存当前的账套id
    setCurrentAccountId(cellObj,nodeId){
        if(AssertUtils.isNotNull(nodeId)){
            cellObj.currentAccountId=nodeId;
        }else{
            nodeId=cellObj.currentAccountId;
        }
        return nodeId;
    },
    getLoadSubGridParams(){

    },
    //添加数据今日到已选数据中
    _addLeftTopRecordToAlreadyGrid(cellObj,rowId, orgGrid,dataFromLabbel,mainFileName="name",dataFrom){
        if (!AssertUtils.isNotNull(orgGrid)) {
            orgGrid = cellObj.leftTopGrid;
        }
        let alreadyGrid = cellObj.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let dataJson = orgGrid.getRowRecord(rowId);
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(rowId) < 0) {
                alreadyGrid.addRow(rowId, [
                    "",
                    dataJson[mainFileName],
                    "",
                    dataFromLabbel,
                    dataFrom
                ]);
            }
        }
    },
    getLoadGridParams(cellObj,nodeId,tabType=""){
        if(!AssertUtils.isNotEmpty(nodeId)){
            if(cellObj.accountTreeObj!=null){
                nodeId=cellObj.accountTreeObj.getSelectedItemId();
            }else{
                nodeId="supperAccount";
            }
        }
        let searVal=$("#" + cellObj.tabId + "_search_input_text").val();

        //如果是编外单位
        //如果是角色 或者是 职务级别
        let backJson = {
            size:10000,
            name: searVal,
            accountId: nodeId
        };
        return backJson;
    },
    /**
     * 初始化职务级别的表格
     * @param cellObj
     * @param moreSel
     * @param selectRelCheck
     * @param headerBar
     * @param colSelBox
     * @param panelType
     */
    initGroupGrid(cellObj,moreSel,selectRelCheck,headerBar,panelType="outUnit"){
        let colSelBox=false;
        if(cellObj.itemConfig["selLeftTopRecord"]){
            colSelBox=true;
        }
        var fieldAry=[
            {
                id: "groupName",
                required: true,
                type: "ro",
                url: "dgk",
                sorting: "str",
                align: "left",
                label: "群组名称",
                width: "*"
            },
            {
                id: "groupFrom",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "单位",
                width: "130"
            }
        ];
        return GridPanelUtils._initGridCommon(cellObj,moreSel,selectRelCheck,headerBar,colSelBox,panelType="role",fieldAry);
    },
    /**
     * 初始化职务级别的表格
     * @param cellObj
     * @param moreSel
     * @param selectRelCheck
     * @param headerBar
     * @param colSelBox
     * @param panelType
     */
    initJobLevelGrid(cellObj,moreSel,selectRelCheck,headerBar,panelType="joblevel"){
        let colSelBox=false;
        if(cellObj.itemConfig["selJobLevel"]){
            colSelBox=true;
        }

        var fieldAry=[
            {
                id: "name",
                required: true,
                type: "ro",
                url: "dgk",
                sorting: "str",
                align: "left",
                label: "职务级别名称",
                width: "*"
            },
            {
                id: "code",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "职务级别代码",
                width: "130"
            }
        ];
        return GridPanelUtils._initGridCommon(cellObj,moreSel,selectRelCheck,headerBar,colSelBox,panelType,fieldAry);
    },
    //初始化编外单位表格
    initOutUnitGrid(cellObj,moreSel,headerBar,panelType="outUnit"){
        let colSelBox=false;
        let selectRelCheck=true;
        if(cellObj.itemConfig["selLeftTopRecord"]){
            colSelBox=true;
            selectRelCheck=false;
        }
        var fieldAry=[
            {
                id: "name",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "外单位名称",
                width: "*"
            },
            {
                id: "belongDepart",
                required: true,
                type: "ro",
                sorting: "str",
                align: "left",
                label: "隶属部门",
                width: "*"
            }
        ];
        return GridPanelUtils._initGridCommon(cellObj,moreSel,selectRelCheck,headerBar,colSelBox,panelType,fieldAry);
    },
    _initGridCommon(cellObj,moreSel,selectRelCheck,headerBar,colSelBox,dataFrom="role",fieldAry,hasSysEvent=true,dataFromLabel){
        let colSelType="checkBox";
        if(cellObj.goTabs["count"]===1){
            colSelType="radioBox";
        }
        let gridConfig = {
            queryUrl: null,
            sysDefEvent:hasSysEvent,
            colOrderNum: true,
            colSelType:colSelType,
            colSelBox: colSelBox,
            hasPagin: false,
            afterLoadData() {
                _afterLoadData(cellObj);
            },
            headerBar: headerBar,
            selectRelCheck:selectRelCheck,
            onClick:(rowId)=>{
                cellObj.dataFrom=dataFrom;
                cellObj.dataFromLabel=dataFromLabel;
                GridPanelUtils._gridClickFun(cellObj,rowId);
            },
            moreSel: moreSel,
            fieldAry:fieldAry
        };
        //已选数据
        let selGrid = InitGridObj(cellObj.tabId + "_left_top_cell_grid", gridConfig, null);
        //如果可以选择岗位 则需要注册checkBox事件
        if(cellObj.itemConfig["selLeftTopRecord"]){
            selGrid.attachEvent("onCheck", function(
                rowId,
                cellInd,
                state,
                type
            ) {
                if(type==='radio'){
                    let alreadyGrid = cellObj.alreadySelGrid;
                    alreadyGrid&&alreadyGrid.clearAll();
                }
                //设置checkBoxEvent
                if (state) {
                    cellObj.addLeftTopRecordToAlreadyGrid(rowId,selGrid);
                } else {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                }
            });
        }
        return selGrid;
    },
    /**
     * 表格点击事件
     * @param cellObj
     * @param rowId
     * @param panelType
     * @private
     */
    _gridClickFun(cellObj, rowId) {
        if (cellObj.itemConfig["selLeftTopRecord"] && cellObj.waitSelGrid) {
            cellObj.waitSelGrid&&cellObj.waitSelGrid.flushGridByUrl({
                url: cellObj.getSubGridQueryUrl(rowId),
                params: GridPanelUtils.getLoadSubGridParams()
            });
        } else {
            if (cellObj.clickType === "flushSubGrid") {
                cellObj.waitSelGrid.flushGridByUrl({
                    url: cellObj.getSubGridQueryUrl(rowId),
                    params: GridPanelUtils.getLoadSubGridParams()
                });
            } else {
                //如果是单选 则需要特殊处理
                if (cellObj.goTabs["count"] === 1) {
                    try{
                        let selGrid=cellObj.leftTopGrid;
                        selGrid.cells(rowId,1).setValue(true);
                    }catch (e) {
                        console.log(e,"error");
                    }

                    _gridSingleSelRecord(cellObj, rowId);
                } else {
                    //如果是多选
                    _gridMoreSelRecord(cellObj, rowId);
                }
            }
        }
    },
    //初始化角色表格
    initRoleGrid(cellObj,moreSel,selectRelCheck,headerBar,cellId,hasSysEvent){
        let colSelBox=false;
        if(cellObj.itemConfig["selLeftTopRecord"]){
            colSelBox=true;
        }
        var fieldAry= [
            {
                id: "roleName",
                required: true,
                type: "ro",
                sorting: "str",
                filter:cellObj.filter,
                align: "left",
                label: "角色名称",
                width: "120"
            },
            {
                id: "roleType",
                required: true,
                type: "sysCoding_ro",
                editorType: "staticDrop",
                items: [
                    { id: "customer", label: "单位自建" },
                    { id: "system", label: "系统角色" },
                    { id: "groupSend", label: "集团下发" }
                ],
                sorting: "str",
                align: "left",
                label: "角色类型",
                width: "*"
            }
        ];
        return GridPanelUtils._initGridCommon(cellObj,moreSel,selectRelCheck,headerBar,colSelBox,cellObj.dataFrom,fieldAry,hasSysEvent,cellObj.dataFromLabel);
    },
    //初始化右边区域的宽度
    initRightCellContent(panelHeight,cellObj,width){
        return cellObj._getRightCellContent(panelHeight - 40 + "px",cellObj,width);
    },
    //初始化左边区域的宽度
    initLeftCellContent(tabCell,treeHeight,departTreeHeight,search_label,tabId,groupCheck=false,accountWid=130,searchInputWid=135){
        return `${tabCell._getLeftPanelCommonTopHeader(accountWid,searchInputWid,search_label,tabCell,groupCheck)}
            <div class="depart-tree-div" style="height: ${treeHeight}">
              <div id="${tabCell.tabId}_left_top_cell_grid" style="height: ${departTreeHeight};"></div>
            </div>`;
    }
};

export default GridPanelUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/gridPanelUtils.js